import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ErrorBoundary, MainBoundary } from '@frontend/error-boundary';
import {
  InsuranceEligibilitySchedulePulseCallout,
  SchedulePulseInsuranceTab,
} from '@frontend/schedule-pulse-insurance-tab';
import { useAppScopeStore } from '@frontend/scope';
import { sentry } from '@frontend/tracking';
import { useGetCalendarV3QueriesData } from '../../../../hooks/scheduler-v3/use-get-calendar-v3-queries-data';
import { useGetCalendarV2QueriesData } from '../../../../hooks/use-get-calendar-v2-queries-data';
import { useSchedulingLocationInfo } from '../../../../hooks/use-scheduling-location-info';
import { useCalendarStore } from '../../../../stores/calendar.store';

interface InsuranceTabContentProps {
  anchorElement: HTMLElement | null;
  isTabActive: boolean;
}

export const InsuranceTabContent = ({ anchorElement, isTabActive }: InsuranceTabContentProps) => {
  const { selectedLocationIds, getScopeName } = useAppScopeStore();
  const { isMultiLocation } = useSchedulingLocationInfo();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { calendarDate: calendarDateV3, setCalendarDate: setCalendarDateV3 } = useCalendarStore([
    'calendarDate',
    'setCalendarDate',
  ]);

  const { appointments: appointmentsV2 } = useGetCalendarV2QueriesData();
  const { calendarEventsData: calendarEventsDataV3 } = useGetCalendarV3QueriesData();

  return (
    <ErrorBoundary
      tier='feature'
      feature='schedule.insurance-tab-content'
      team='fe-schedule'
      fallback={MainBoundary}
      onError={(error, componentStack, eventId) => {
        console.error('Error in InsuranceTabContent', error, componentStack, eventId);
        sentry.error({
          error,
          team: 'fe-rcm',
          topic: 'scheduling',
          severityLevel: 'error',
          addContext: {
            name: 'insurance-tab-error',
            context: {
              componentStack,
              eventId,
              selectedLocationIds,
              calendarDate: calendarDateV3,
              isMultiLocation,
              isScheduleV3FlagEnabled,
            },
          },
        });
      }}
    >
      <SchedulePulseInsuranceTab
        defaultAppointmentList={isScheduleV3FlagEnabled ? calendarEventsDataV3?.events ?? [] : appointmentsV2}
        selectedDate={calendarDateV3}
        setSelectedDate={setCalendarDateV3}
        selectedLocationIds={selectedLocationIds}
        getScopeName={getScopeName}
        isMultiLocation={isMultiLocation}
      />
      <InsuranceEligibilitySchedulePulseCallout anchorElement={anchorElement} isTabActive={isTabActive} />
    </ErrorBoundary>
  );
};
